import { render, staticRenderFns } from "./bindmobile.vue?vue&type=template&id=1ca6de2f&scoped=true&"
import script from "./bindmobile.vue?vue&type=script&lang=js&"
export * from "./bindmobile.vue?vue&type=script&lang=js&"
import style0 from "./bindmobile.vue?vue&type=style&index=0&id=1ca6de2f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6de2f",
  null
  
)

export default component.exports